<template>
  <div>
    <v-container v-if="gameInformation" class="pt-0">
      <v-row class="no-gutters">
        <v-col
          cols="12"
          class="pt-0 pb-0"
          v-if="gameInformation.portals && gameInformation.portals.length > 0"
        >
          <span
            class="portal caption"
            v-for="portal in gameInformation.portals"
            v-bind:key="portal.uid"
            >{{ portal.name }}&nbsp;</span
          >
        </v-col>
        <v-col cols="12" class="pt-0">
          <div class="mb-2">
            <span class="headline">
              <multi-icon
                :iconSize="'1.1em'"
                :icon="getGameTypeIcon(gameInformation.type)"
                :rightBottomIcon="getPlatformIcon(gameInformation.platform)"
                :rightBottomIconColor="'var(--v-secondary-base)'"
                style="position: relative; top: -0.06em"
              />
              &nbsp;{{ gameInformation.name }}</span
            >
          </div>
          <div v-if="gameInformation.state != 'active'">
            <span class="overline">{{ stateText }}</span>
          </div>
          <advertising-content />
        </v-col>
      </v-row>
      <v-row v-if="showCheckin">
        <v-col cols="12">
          <game-checkin :game="gameInformation" />
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col>
          <div v-if="!secret">
            <league-game-overview
              v-if="gameInformation.type == 'league.classic'"
              :game="gameInformation"
              :tabKey="tabKey"
              :hideChat="hideChat"
              :disableRouting="disableRouting"
            />
            <ko-game-overview
              v-else-if="gameInformation.type == 'ko.classic'"
              :game="gameInformation"
              :tabKey="tabKey"
              :hideChat="hideChat"
              :disableRouting="disableRouting"
            />
            <groupphase-with-ko-game-overview
              v-else-if="gameInformation.type == 'groupphase_with_ko'"
              :game="gameInformation"
              :tabKey="tabKey"
            />
            <ko-mixed-game-overview
                v-else-if="gameInformation.type == 'ko.mixed'"
                :game="gameInformation"
                :tabKey="tabKey"
                :hideChat="hideChat"
                :disableRouting="disableRouting"
            />
          </div>
          <div v-else>
            <ko-game-public
              v-if="gameInformation.type == 'ko.classic'"
              :game="gameInformation"
              :tabKey="tabKey"
            />
            <league-game-public
              v-else-if="gameInformation.type == 'league.classic'"
              :game="gameInformation"
              :tabKey="tabKey"
            />
            <groupphase-with-ko-game-overview
              v-else-if="gameInformation.type == 'groupphase_with_ko'"
              :game="gameInformation"
              :hideChat="true"
              :tabKey="tabKey"
            />
            <ko-mixed-game-public
                v-else-if="gameInformation.type == 'ko.mixed'"
                :game="gameInformation"
                :tabKey="tabKey"
                :hideChat="hideChat"
                :disableRouting="disableRouting"
            />
            <div v-else>N/A</div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {} from "@/plugins/store";
import {
  EVENT_REFRESH_DATA,
  EVENT_GAMEINSTANCE_UPDATED,
  EVENT_PUSHER_EVENT_RECEIVED,
} from "@/plugins/eventbus";
import LeagueGameOverview from "@/widgets/LeagueGameOverview";
import KoGameOverview from "@/widgets/KOGameOverview";
import platformMixins from "@/mixins/platformMixins";
import gameTypeMixin from "@/mixins/gameTypeMixin";
import AdvertisingContent from "@/widgets/AdvertisingContent";
import GameCheckin from "@/widgets/GameCheckin";
import Vue from "vue";
import KoGamePublic from "../widgets/KOGamePublic.vue";
import LeagueGamePublic from "../widgets/LeagueGamePublic.vue";
import GroupphaseWithKoGameOverview from "../widgets/GroupphaseWithKOGameOverview.vue";
import KoMixedGameOverview from "../widgets/KoMixedGameOverview.vue";
import KoMixedGamePublic from "../widgets/KoMixedGamePublic.vue";

export default {
  name: "GameOverview",
  mixins: [platformMixins, gameTypeMixin],
  components: {
    LeagueGameOverview,
    KoGameOverview,
    AdvertisingContent,
    GameCheckin,
    KoGamePublic,
    LeagueGamePublic,
    GroupphaseWithKoGameOverview,
    KoMixedGameOverview,
    KoMixedGamePublic,
  },
  props: {
    gameUID: String,
    tabKey: {
      type: String,
      required: false,
    },
    secret: String,
    disableRouting: {
      type: Boolean,
      default: false,
    },
    hideChat: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return {
      gameInformation: undefined,
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    stateText() {
      let state = this.gameInformation.state;
      return this.$t("competition.state." + state);
    },
    showCheckin() {
      return (
        this.$store.state.isLoggedIn && this.gameInformation.state == "checkin"
      );
    },
    channelName() {
      return "App.GameOverview." + this.gameUID;
    },
  },
  watch: {
    gameUID: function (val, oldVal) {
      console.log("gameUID changed to " + val + " old: " + oldVal);
      try {
        this.$realtime.leaveChannel("App.GameOverview." + oldVal);
        this.listenToRealtimeEvents("App.GameOverview." + val);
      } catch (e) {
        console.log(e);
      }
      this.reset();
      this.loadOverview();
    },
    secret: function () {
      this.gameInformation = null;
      this.loadOverview();
    },
  },
  mounted() {
    this.loadOverview();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
    this.$eventBus.$on(EVENT_GAMEINSTANCE_UPDATED, this.onGameinstanceUpdated);
    this.$eventBus.$on(EVENT_PUSHER_EVENT_RECEIVED, this.onPusherEvent);
    Vue.nextTick(() => {
      this.listenToRealtimeEvents(this.channelName);
    });
  },

  beforeDestroy() {
    console.log("GameOverview before destroy");
    this.$realtime.leaveChannel(this.channelName);
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
    this.$eventBus.$off(EVENT_GAMEINSTANCE_UPDATED, this.onGameinstanceUpdated);
    this.$eventBus.$off(EVENT_PUSHER_EVENT_RECEIVED, this.onPusherEvent);
  },

  methods: {
    listenToRealtimeEvents(channelName) {
      if (this.$realtime.echo) {
        let gameinstanceEventsListenTo = [
          "Client\\MatchResultAdded",
          "Client\\GameStateChanged",
          "Client\\GameRoundAdded",
          "Client\\GamePlayerAdded",
          "Client\\GamePlayerUpdated",
          "Client\\GamePotUpdated",
        ];

        if (this.$common.isDevEnv()) {
          console.log("Listening to game overview channel " + channelName);
        }
        gameinstanceEventsListenTo.forEach((eventName) => {
          this.$realtime.echo.private(channelName).listen(eventName, (e) => {
            let eventBusEvent = {
              type: eventName,
              event: e,
            };
            if (this.$common.isDevEnv()) {
              console.log(
                "[DEV] sending received pusher event to $eventbus",
                eventBusEvent
              );
            }
            this.$eventBus.$emit(EVENT_PUSHER_EVENT_RECEIVED, eventBusEvent);
          });
        });
      } else {
        console.log("WARN: Echo is not available for GameOverview!");
      }
    },
    onRefreshData() {
      this.loadOverview();
    },
    onGameinstanceUpdated(gameinstance) {
      if (!this.gameInformation) {
        return;
      }
      if (this.gameInformation.uid == gameinstance.uid) {
        this.gameInformation = gameinstance;
      }
    },
    onPusherEvent(e) {
      // console.log("GameOverview Pusher event received", e);
      if (!this.gameInformation) {
        return;
      }
      if (e.type == "ChatGroupUserStateUpdated") {
        if (e.event.chatGroupName == this.gameInformation.chatUid) {
          // ChatGroup updated for my loaded game
          if (e.event.unreadMessages || e.event.unreadMessages === 0) {
            this.gameInformation.yourUnreadChatMessages =
              e.event.unreadMessages;
          }
        }
      } else if (e.type == "Client\\GameStateChanged") {
        if (e.event.gameUid == this.gameInformation.uid) {
          this.$eventBus.$emit(EVENT_REFRESH_DATA);
        }
      } else if (e.type == "Client\\GameRoundAdded") {
        if (e.event.gameUid == this.gameInformation.uid) {
          this.$eventBus.$emit(EVENT_REFRESH_DATA);
        }
      } else if (e.type == "Client\\GamePlayerUpdated") {
        if (e.event.gameUid == this.gameInformation.uid) {
          this.gameInformation.participants.forEach((p) => {
            if (p.uid == e.event.player.uid) {
              let playerPatch = e.event.player;
              let playerProps = Object.keys(playerPatch);
              playerProps.forEach((prop) => {
                let val = playerPatch[prop];
                if (val !== undefined && val !== null) {
                  p[prop] = val;
                }
              });
            }
          });
        }
      } else if (e.type == "Client\\GamePlayerAdded") {
        if (e.event.gameUid == this.gameInformation.uid) {
          var participant = this.gameInformation.participants.find((p) => {
            return p.uid == e.event.player.uid;
          });
          if (!participant) {
            this.gameInformation.participants.push(e.event.player);
          }
        }
      } else if (e.type == "Client\\GamePotUpdated") {
        if (e.event.gameUid == this.gameInformation.uid) {
          this.gameInformation.pot = e.event.pot;
        }
      }
    },
    reset() {
      this.gameInformation = undefined;
    },
    loadOverview() {
      // console.log(`Loading game overview of ${this.gameUID}`);
      this.$api
        .getGameInstanceInformation(this.gameUID)
        .then((response) => {
          let data = response.data;
          this.gameInformation = data;
        })
        .catch((error) => {
          this.$common.onError(error);
        });
    },
  },
};
</script>
